import * as actionTypes from '../actions/actionTypes';

const initialState = {
  headers: {
    headers: [],
    count: "",
    isLoading: false,
    isError: false
  },
  createHeaderData: {},
  isLoading: false,
  isError: false,
  editHeader: {},
  editHeaderData: {},
  deleteHeaderData: {
    isLoading: false,
    isError: false,
    data: {}
  }  
}

const headerReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_HEADER_LIST:
      return { ...newState, headers: { ...newState.headers, isLoading: true } };

    case actionTypes.FETCH_HEADER_LIST_SUCCESS:
      return { ...newState, headers: { headers: [...action.payload], count: action.payload.totalCount, isLoading: false, isError: false } };

    case actionTypes.FETCH_HEADER_LIST_FAILURE:
      return { isLoading: false, isError: true };
    
    case actionTypes.RESET_CREATE_HEADER_CONFIG_STATE:
      return { ...newState, isLoading: false, createHeaderData: {} };

    case actionTypes.CREATE_HEADER:
      return { ...newState, isLoading: true, createHeaderData: {} };

    case actionTypes.CREATE_HEADER_SUCCESS:
      return { ...newState, isLoading: false, createHeaderData: { ...action.payload } };

    case actionTypes.CREATE_HEADER_FAILURE:
      return { ...newState, isLoading: false, isError: true, createHeaderData: { ...action.payload } };

    case actionTypes.RESET_EDIT_HEADER_CONFIG_STATE:
          return { ...newState, isLoading: false, editHeaderData: {} };

    case actionTypes.EDIT_HEADER:
      return { ...newState, isLoading: true };

    case actionTypes.EDIT_HEADER_SUCCESS:
      return { ...newState, isLoading: false, editHeaderData: { ...action.payload } };

    case actionTypes.EDIT_HEADER_FAILURE:
      return { ...newState, isLoading: false, isError: true, editHeaderData: { ...action.payload } };

    case actionTypes.DELETE_HEADER:
      return { ...newState, deleteHeaderData: { isLoading: true } };

    case actionTypes.DELETE_HEADER_SUCCESS:
      return { ...newState, deleteHeaderData: { isLoading: false, data: { ...action.payload } } };

    case actionTypes.DELETE_HEADER_FAILURE:
      return { ...newState, deleteHeaderData: { isLoading: false, data: { ...action.payload } } };

    default:
      return { ...newState };
  }
};


export default headerReducer;